import { createCommand } from '@commander-js/extra-typings';
import type { GetAstroRootCommandFn } from '@wix/cli-command-contract';

import { buildCommand } from './build.js';
import { connectCommand } from './connect.js';
import { envCommand } from './env.js';
import { previewCommand } from './preview.js';
import { promoteCommand } from './promote.js';
import { releaseCommand } from './release.js';
import { devCommand } from './dev.js';
import { generateCommand } from './generate.js';
import { translationCommand } from './translation.js';
import { skillsCommand } from './skills.js';
import { schemaCommand } from './schema.js';
import { devSiteCommand } from './dev-site.js';

export const getRootCommand: GetAstroRootCommandFn = async (
  services,
  cliVersion
) => {
  const rootCommand = createCommand('astro')
    .enablePositionalOptions(true)
    .addCommand(buildCommand(services, cliVersion))
    .addCommand(connectCommand(services, cliVersion))
    .addCommand(envCommand(services, cliVersion))
    .addCommand(previewCommand(services, cliVersion))
    .addCommand(skillsCommand(services, cliVersion))
    .addCommand(promoteCommand(services, cliVersion), { hidden: true })
    .addCommand(releaseCommand(services, cliVersion))
    .addCommand(devCommand(services, cliVersion))
    .addCommand(generateCommand(services, cliVersion))
    .addCommand(schemaCommand(services, cliVersion))
    .addCommand(translationCommand(services, cliVersion), { hidden: true });

  if (services.definedWixConfig.config.projectType === 'App') {
    rootCommand.addCommand(devSiteCommand(services, cliVersion));
  }

  return rootCommand;
};

export const getLimitedRootCommand: GetAstroRootCommandFn = async (
  services,
  cliVersion
) => {
  return createCommand('astro')
    .enablePositionalOptions(true)
    .addCommand(previewCommand(services, cliVersion))
    .addCommand(releaseCommand(services, cliVersion));
};
